import React, { useState } from "react";
import { login } from "../../api/user.api.js";
import { useAuth } from "../../context/auth.context.js";
import { Button, TextField, Typography } from "@mui/material";
import { useSnackbar } from "../../context/snackbar.context.js";

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const auth = useAuth();
  const showSnackbar = useSnackbar();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    login(formData.email, formData.password)
      .then((response) => {
        auth.login(response.data);
      })
      .catch((error) =>
        showSnackbar(`Login failed - ${error.response.data.reason}`, "error")
      );
  };

  return (
    <div className="login-container">
      <div>
        <form onSubmit={handleSubmit}>
          <Typography variant="h3">Login</Typography>
          <div>
            <TextField
              id="email"
              label="Email"
              name="email"
              variant="outlined"
              type="text"
              fullWidth
              value={formData.email}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
            <TextField
              id="password"
              label="Password"
              name="password"
              variant="outlined"
              type="password"
              fullWidth
              value={formData.password}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <Button variant="contained" type="submit">
            Login
          </Button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
